import StoryblokService from '~/services/StoryblokService'

export const state = () => ({
  language: 'en',
  app: {
    breakpoint: null,
    breakpoints: {
      xs: 640,
      sm: 768,
      md: 1024,
      lg: 1280,
    },
    containerWidth: null,
    innerWidth: null,
    navOpened: false,
  },
  story: {},
  settings: {
    hideBanner: false,
    videoSrc: '',
    videoText: '',
    videoBtnText: '',
    videoPoster: '',
    promoLink: '',
    promoLinkTarget: '',
    promoMobileBtnText: '',
    promoLgBtnText: '',
    homeUrl: '',
    accountUrl: '',
    mainNav: [],
    mobileNav: [],
    mainNavStyle: '',
    hideNav: '',
    asideNav: [],
    footerLogo: '',
    footerNav: [],
    footerSocials: [],
    footerLegal: [],
    footerCaption: '',
    footerCopyright: '',
    hideFooter: true,
    preFooter: [],
    stats: {},
  },
})

export const getters = {
  getFooterData: (state) => ({
    footerLogo: state.settings.footerLogo,
    footerNav: state.settings.footerNav,
    footerSocials: state.settings.footerSocials,
    footerLegal: state.settings.footerLegal,
    footerCaption: state.settings.footerCaption,
    footerCopyright: state.settings.footerCopyright,
    hideFooter: state.settings.hideFooter,
  }),
}

export const mutations = {
  setStory: (state, story) => {
    state.story = story
  },
  setLanguage: (state, lang) => {
    state.language = lang
  },
  setSettings: (state, payload) => {
    state.settings = { ...state.settings, ...payload }
  },
  setStats: (state, stats) => {
    state.settings = { ...state.settings, stats }
  },
  setBreakpoint: (state, breakpoint) => {
    state.app = { ...state.app, breakpoint }
  },
  setContainerWidth: (state, containerWidth) => {
    state.app = { ...state.app, containerWidth }
  },
  setInnerWidth: (state, innerWidth) => {
    state.app = { ...state.app, innerWidth }
  },
  setNavOpened: (state, navOpened) => {
    state.app = { ...state.app, navOpened }
  },
}

export const actions = {
  loadData(storeContext, payload) {
    storeContext
      .dispatch('fetchData', payload)
      .then(
        (res) =>
          res.statusCode !== 404 &&
          storeContext.dispatch('updateStore', { ...res, lang: payload.lang })
      )
  },
  updateStore(storeContext, { main = {}, settings = {}, lang = 'en' }) {
    storeContext.commit('setStory', main.story)
    storeContext.commit('setLanguage', lang)
    storeContext.commit('setSettings', {
      videoSrc: settings.story?.content?.video_src,
      videoPoster: settings.story?.content?.video_poster,
      // videoText: settings.story?.content?.video_text,
      // videoBtnText: settings.story?.content?.video_btn_text,
      // promoLink: settings.story?.content?.link,
      // promoLinkTarget: settings.story?.content?.link_target,
      // promoMobileBtnText: settings.story?.content?.mobile_btn_text,
      // promoLgBtnText: settings.story?.content?.lg_btn_text,
      bannerText: settings.story?.content?.banner_text,
      bannerCtaTextMobile: settings.story?.content?.banner_cta_text_mobile,
      bannerCtaTextTablet: settings.story?.content?.banner_cta_text_tablet,
      bannerCtaTextDesktop: settings.story?.content?.banner_cta_text_desktop,
      bannerLink: settings.story?.content?.banner_link,
      bannerLinkTarget: settings.story?.content?.banner_link_target,
      showBanner: settings.story?.content?.show_banner,
      showBannerCta: settings.story?.content?.show_banner_cta,
      homeUrl: settings.story?.content?.home_url?.url,
      accountUrl: settings.story?.content?.account_url?.url,
      // mainNav: settings.story?.content?.main_navigation,
      navTrays: settings.story?.content?.nav_trays,
      mobileNav: settings?.story?.content?.mobile_navigation,
      mainNavStyle:
        main.story?.content?.nav_style_override ||
        settings?.story?.content?.nav_style,
      hideBanner: main.story?.content?.hide_banner,
      hideNav: main.story?.content?.hide_nav,
      asideNav: main.story?.content?.navigation,
      footerLogo: settings?.story?.content?.footer_logo,
      footerNav: settings?.story?.content?.footer_navigation,
      footerSocials: settings?.story?.content?.footer_socials,
      footerLegal: settings?.story?.content?.footer_legal,
      footerCaption: settings?.story?.content?.footer_caption,
      footerCopyright: settings?.story?.content?.footer_copyright,
      hideFooter: main.story?.content?.hide_footer,
      preFooter: settings?.story?.content?.prefooter,
    })
  },
  async fetchData(_, payload) {
    const context = this.app.context

    const main = await StoryblokService.getStory(context, payload.path)
    const settings = await StoryblokService.getStory(
      context,
      payload.lang === 'en' ? 'settings' : `${payload.lang}/settings`
    )

    if (!main) {
      return context.error({ statusCode: 404, message: 'page does not exist' })
    }

    return { main, settings }
  },
}
